// Scroll Morph Handler
// - Überblendung zwischen .normal und .morph Bildern gekoppelt an Scroll-Fortschritt
// - Beginn: Element in Bildschirmmitte
// - Ende: Element am oberen Rand (minus Topbar-Höhe)
// - Bidirektional: Vorwärts und Rückwärts-Scrollen funktioniert

const TOPBAR_HEIGHT = 80; // px - CSS @topbar-height

interface MorphConfig {
	container: HTMLElement;
	morphImg: HTMLImageElement;
}

export function initScrollMorph(): void {
	const morphContainers = document.querySelectorAll('.foto-morph');
	
	if (!morphContainers.length) return;

	const configs: MorphConfig[] = Array.from(morphContainers)
		.map(container => {
			const morphImg = container.querySelector('img.morph') as HTMLImageElement;
			return { container: container as HTMLElement, morphImg };
		})
		.filter(config => config.morphImg);

	if (!configs.length) return;

	// Update Morph-Opacity kontinuierlich beim Scroll
	const updateMorphOpacity = () => {
		configs.forEach(({ container, morphImg }) => {
			// Bounding Rect vom Container
			const rect = container.getBoundingClientRect();
			const containerCenter = rect.top;// + rect.height / 2;
			const isMobile = window.matchMedia('(max-width:768px)').matches;

			// Viewpoint-Breiten
			const viewportHeight = window.innerHeight;
			const startPoint = isMobile ? viewportHeight * 0.45 - 100 : viewportHeight * 0.45; // Bildschirmmitte
			const endPoint = isMobile ? TOPBAR_HEIGHT : TOPBAR_HEIGHT + 100; // Oberer Rand minus Topbar

			// Scroll-Fortschritt berechnen (0 = Start, 1 = Ende)
			// Wenn Container-Mitte in Bildschirmmitte ist: progress = 0
			// Wenn Container-Mitte am oberen Rand ist: progress = 1
			const distanceFromMidpoint = startPoint - containerCenter;
			const activationRange = startPoint - endPoint;

			// Fortschritt clamped zwischen 0 und 1
			let progress = distanceFromMidpoint / activationRange;
			progress = Math.max(0, Math.min(1, progress));

			// Opacity setzen (nur für .morph Bild)
			morphImg.style.opacity = String(progress);
		});
	};

	// Mit requestAnimationFrame für optimale Performance
	const animationLoop = () => {
		updateMorphOpacity();
		requestAnimationFrame(animationLoop);
	};

	animationLoop();
}
